import { render, staticRenderFns } from "./PublishManualVersionSidebar.vue?vue&type=template&id=1e4c0d1e"
import script from "./PublishManualVersionSidebar.vue?vue&type=script&lang=js"
export * from "./PublishManualVersionSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports